import React from "react";
import IntFileList from "../component/IntFileList";

const IntFileListContainer = () => (<IntFileList />)

export default IntFileListContainer;